

















































































































































































































import {Vue, Component, Prop, Emit, namespace} from 'nuxt-property-decorator'
import { FileUpload, FormSelect, HtmlEditor } from '@frontend/components'
import Autocomplete from '@/components/Autocomplete.vue'
import algolia from '@/algolia'
import gateway from '@/gateway'
import Sortable from '@/directives/sortable'
import QuickSelector from '@/components/QuickSelector.vue'
import TileFormComponent from './TileFormComponent.vue'
import { Debounce } from '../helpers'

@Component({
  components: {
    Autocomplete,
    HtmlEditor,
    QuickSelector,
    FileUpload,
    FormSelect,
    TileFormComponent,
  },
  directives: {
    Sortable,
  },
})
export default class IndexForm extends Vue {
  @Prop({default: false, type: Boolean}) loading

  @namespace('channels').Getter channels
  @namespace('indices').Getter indices
  @namespace('indices').Action getSearchIndices
  @namespace('indices').Getter currentIndex

  get draft() {
    return this.currentIndex.draft
  }

  get channel() {
    return this.draft.channel
  }
  get title() {
    return this.draft.title || ''
  }
  get analysts() {
    return this.draft.analysts || []
  }

  errors = null
  highlightFields = false
  imageUploadUrl = process.env.VUE_APP_API_ENDPOINT + 'upload/image'
  fileUploadUrl = process.env.VUE_APP_API_ENDPOINT + 'upload/file'

  analystList = []
  tags = []


  @Emit()
  save(data) {
    return data
  }

  @Emit()
  update(data) {
    return data
  }

  @Emit()
  cancel() {}

  @Emit()
  publish() {
    return this.draft
  }

  isAnEditor () {
    return this.$login.can('indices.update')
  }

  @Debounce(500)
  async delayGetAnalysts(search) {
    const params: any = {}
    if (search) {
      params.search = encodeURIComponent(search)
    }
    if (this.channel) {
      params.providerIds = [this.channel.id]
    }
    const response = await gateway.get(`cms/analysts`, {
      params,
    })
    this.analystList = response.data.data.map(x => ({
        id: x.id,
        name: x.user.name,
        tagId: x.tag.id,
        picture: {
          square: x.user.pictureSq
            ? `https://cdn.tellimer.com/users/${x.user.pictureSq}`
            : 'https://cdn.tellimer.com/analysts/default-sq-tellimer.svg',
          round: x.user.picture
            ? `https://cdn.tellimer.com/users/${x.user.picture}`
            : 'https://cdn.tellimer.com/analysts/default-sq-tellimer.svg',
        },
      }))
  }

  @Debounce(500)
  searchTags(query) {
    const index = algolia.initIndex('tags')
    index.search({
      query,
      hitsPerPage: 10,
    }, (err, { hits } = {}) => {
      this.tags = hits.map((hit) => ({
        ...hit,
        id: hit.objectID,
      }))
    })
  }

  onAnalystsSort (sort) {
    const analyst = this.draft.analysts[sort.oldIndex]
    const analysts = this.analysts
    analysts.splice(sort.oldIndex, 1)
    analysts.splice(sort.newIndex, 0, analyst)

    this.update({analysts})
  }

  async onChannelChange (channelData) {
    const channel = {
      id: channelData.id,
      badge: channelData.badge_url,
      name: channelData.name,
      slug: channelData.slug,
    }
    this.update( {channel})
  }

  removeAnalyst (index) {
    const analysts = this.analysts
    analysts.splice(index, 1)
    this.update({analysts})
  }

  @Debounce(500)
  updateTitle (title) {
    this.update( {title})
  }

  updateAnalysts (analysts) {
    this.update({analysts})
  }

  updateTags (tags) {
    this.update( {tags})
  }

  removeTag (index) {
    const {tags = []} = this.draft
    tags.splice(index, 1)
    this.update( {tags})
  }

  get token () {
    return `Bearer ${this.$login.getToken()}`
  }

  @Debounce(500)
  async searchIndices(search) {
    const params = {
      search: encodeURIComponent(search),
      slug: this.currentIndex.slug,
      onlyPublished: 1,
    }
    await this.getSearchIndices(params)
  }

  addRelatedIndex (relatedIndex) {
    const {relatedIndices = []} = this.draft
    relatedIndices.push(relatedIndex)
    this.update( {relatedIndices})
  }

  removeRelatedIndex (index) {
    const {relatedIndices = []} = this.draft
    relatedIndices.splice(index, 1)
    this.update( {relatedIndices})
  }

  addNewTile() {
    const {tiles = []} = this.draft
    tiles.push({
      title: '',
      body: null,
      file: '',
      cover: '',
    })
    this.update( {tiles})
  }

  @Debounce(500)
  updateTile(key, tile) {
    const { tiles = [] } = this.draft
    tiles[key] = {
      ...tiles[key],
      ...tile
    }
    this.update({tiles})
  }
}
